import { useEffect } from 'react';
import EventLocation from '~/constants/dealership/EventLocation';
import usePushToAdobe from '~/hooks/dealership/usePushToAdobe';
import getAdobeEventPageType from '~/utilities/dealership/getAdobeEventPageType';

function isAnchorElement(el: HTMLElement): el is HTMLAnchorElement {
  return el.tagName.toLowerCase() === 'a';
}

export default function useTrackAdobeNavigationEvent() {
  const pushToAdobe = usePushToAdobe();

  useEffect(() => {
    function onClick(ev: MouseEvent) {
      if (!(ev.target instanceof Element)) return;

      const el = ev.target.closest<HTMLElement>('a, [data-adobe-id]');

      if (el == null) return;

      const { isClickToCall, isGetDirections } = isAnchorElement(el)
        ? {
            isClickToCall: el.href.startsWith('tel:'),
            isGetDirections: el.href.includes('google.com/maps')
          }
        : {
            isClickToCall: false,
            isGetDirections: false
          };

      const eventPageType = getAdobeEventPageType();
      const eventLocation = ev.target.closest('header')
        ? EventLocation.Header
        : ev.target.closest('footer')
        ? EventLocation.Footer
        : ev.target.closest('[role="dialog"]')
        ? EventLocation.Overlay
        : EventLocation.Body;
      const eventDescription =
        el.dataset.adobeId ||
        (isAnchorElement(el)
          ? ev.target.textContent?.toLowerCase()?.replace(/[^a-zA-Z0-9]+/g, '-')
          : undefined);

      if (!eventDescription) return;

      pushToAdobe({
        event: 'interaction-click',
        eventType: { isClickToCall, isGetDirections },
        interaction: {
          site: 'dealer',
          type: isClickToCall ? 'func' : 'nav',
          page: eventPageType,
          location: eventLocation,
          description: eventDescription
        }
      });
    }

    window.addEventListener('click', onClick, true);

    return () => {
      window.removeEventListener('click', onClick, true);
    };
  }, [pushToAdobe]);
}
